//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
SPLM.DisplayPartOption = Object.freeze({
    "ReplaceExisting" : "ReplaceExisting", "AllowAdditional" : "AllowAdditional"});

SPLM.PartDisplayPartWorkPartOption = Object.freeze({
    "SameAsDisplay" : "SameAsDisplay", "UseLast" : "UseLast"});

SPLM.PartLoadState = Object.freeze({
    "NotLoaded" : "NotLoaded", "FullyLoaded" : "FullyLoaded", "PartiallyLoaded" : "PartiallyLoaded", "MinimallyLoaded" : "MinimallyLoaded"});

export default SPLM;